import { jsxs as n, jsx as o } from "react/jsx-runtime";
const i = ({
  width: r,
  height: t,
  className: e
}) => /* @__PURE__ */ n(
  "svg",
  {
    className: e,
    fill: "none",
    height: t,
    viewBox: "0 0 20 20",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M18.3333 6.89199V3.52533C18.3333 2.20033 17.8 1.66699 16.475 1.66699H13.1083C11.7833 1.66699 11.25 2.20033 11.25 3.52533V6.89199C11.25 8.21699 11.7833 8.75033 13.1083 8.75033H16.475C17.8 8.75033 18.3333 8.21699 18.3333 6.89199Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M8.74935 7.10033V3.31699C8.74935 2.14199 8.21602 1.66699 6.89102 1.66699H3.52435C2.19935 1.66699 1.66602 2.14199 1.66602 3.31699V7.09199C1.66602 8.27533 2.19935 8.74199 3.52435 8.74199H6.89102C8.21602 8.75033 8.74935 8.27533 8.74935 7.10033Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M8.74935 16.475V13.1083C8.74935 11.7833 8.21602 11.25 6.89102 11.25H3.52435C2.19935 11.25 1.66602 11.7833 1.66602 13.1083V16.475C1.66602 17.8 2.19935 18.3333 3.52435 18.3333H6.89102C8.21602 18.3333 8.74935 17.8 8.74935 16.475Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M12.5 12.917H17.5",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M12.5 16.25H17.5",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "1.25"
        }
      )
    ]
  }
);
export {
  i as Content
};
